import {
  deleteField,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
} from 'firebase/firestore';
import { RatingSentence } from '../types/rating-sentence';
import BaseService from './base-service';

class RatingsService extends BaseService<RatingSentence> {
  constructor() {
    super('ratings');
  }

  async update(rating: RatingSentence): Promise<void> {
    if (!rating.id) throw new Error('Cannot update a document without an ID');

    return await updateDoc(doc(this.collectionRef, rating.id.toString()), {
      text: rating.text,
      categoryId: rating.categoryId,
      feminine: rating.feminine ?? deleteField(),
    });
  }

  async getByCategoryIds(categoryIds: string[]): Promise<RatingSentence[]> {
    const chunks = this.chunkArray(categoryIds, 10);
    const ratings: RatingSentence[] = [];

    for (const chunk of chunks) {
      const q = query(this.collectionRef, where('categoryId', 'in', chunk));
      const snapshot = await getDocs(q);
      snapshot.forEach((doc) => {
        ratings.push({ id: doc.id, ...(doc.data() as RatingSentence) });
      });
    }

    return ratings.toSorted((a, b) => a.text.localeCompare(b.text));
  }

  private chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks = [];

    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }

    return chunks;
  }
}

const ratingsService = new RatingsService();
export default ratingsService;
